import { useOrgSnapshot } from "../../hooks/useOrgSnapshot";
import { useAuth } from "../../hooks/useAuth";
import { PageHeader } from "../../components/AppLayout";
import { Card } from "../../components/shared/Card";
import { Spinner } from "../../components/shared/Spinner";
import { tierDisplayName } from "../../lib/format";

export function OwnerOverview() {
  const { profile } = useAuth();
  const { org, role, loading } = useOrgSnapshot();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Spinner />
      </div>
    );
  }

  const orgData = (org ?? {}) as {
    name?: string;
    type?: string;
    activeTier?: string | null;
    seatCount?: number;
  };

  const displayName =
    (profile as { display_name?: string } | null)?.display_name?.trim() ?? "";
  const greeting = displayName ? `Hola, ${displayName}` : "Hola";

  return (
    <>
      <PageHeader
        title={greeting}
        subtitle={orgData.name ? `${orgData.name} · ${orgData.type ?? "—"}` : undefined}
      />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <StatCard
          label="Plan"
          value={tierDisplayName(orgData.activeTier ?? null)}
        />
        <StatCard label="Seats" value={String(orgData.seatCount ?? 0)} />
        <StatCard label="Mi rol" value={role ?? "—"} />
      </div>

      <p className="mt-8 text-xs text-ink-3">
        Usa la barra lateral para gestionar pagos, tu suscripción de API,
        el equipo y los skills. ¿Necesitas ayuda? hello@cowboys.so
      </p>
    </>
  );
}

function StatCard({ label, value }: { label: string; value: string }) {
  return (
    <Card className="p-5">
      <div className="text-xs font-semibold uppercase tracking-wider text-ink-3">
        {label}
      </div>
      <div className="mt-2 flex items-baseline gap-2">
        <div className="text-2xl font-black text-ink">{value}</div>
      </div>
    </Card>
  );
}
